(function () {
  "use strict";

  DeleteShopifyCourseCtrl.$inject = ['$scope', '$rootScope', '$timeout'];
  angular
    .module('trainerWebApp.modals')
    .controller('DeleteShopifyCourseCtrl', DeleteShopifyCourseCtrl);

  function DeleteShopifyCourseCtrl($scope, $rootScope, $timeout) {

    $scope.modal = {
      content: 0,
      data: {},
      status: '',
      confirmed: false
    };

    $scope.deleteShopifyCourse = function () {
      $scope.modal.status = 'saving';
      $scope.modal.confirmed = true;
      $rootScope.$broadcast('shopifyCourseDeletionConfirmedEvent', $scope.modal.data, function () {
        $scope.dismiss();
        $timeout(function () {
          $scope.modal.status = ''
        }, 500);
      });
    };

    $scope.$on('shopifyCourseDeletionRequestedEvent', function (event, course) {

      $scope.modal.status = '';
      $scope.modal.data = course;
      $scope.modal.content = course.name;
      $scope.modal.confirmed = false;

      if (!$scope.$root.$$phase)
        $scope.$apply();

      $scope.show();
    });
  }

})();
